<template>
  <div class="empty-list school-base" v-if="isSchoolBased">
    <img src="@/assets/images/school-empty.png" style="width: 182px" alt="" />
    <span class="text">暂无资源，快去上传吧~</span>
    <div class="btn" data-io-click="tracker"  @click="getUploadFile">上传资源</div>
  </div>
  <div class="empty-list" v-else>
    <img src="@/assets/images/empty.png" alt="" />
    <span class="text">{{ text }}</span>
    <div v-if="isSchoolBased" class="btn" data-io-click="tracker"  @click="getUploadFile">请上传</div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "列表为空～",
    },
    isSchoolBased: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getUploadFile() {
      this.$emit("uploadFile");
    },
  },
};
</script>
<style scoped lang="scss">
.school-base {
}

.empty-list {
  padding: 160px 0 100px;
  text-align: center;
  background: #fff;

  .text {
    margin-top: 20px;
    display: block;
    font-size: 14px;
    color: #333;
  }

  .btn {
    color: #0057ff;
    border: 1px solid #0057ff;
    line-height: 26px;
    border-radius: 6px;
    padding: 0 10px;
    display: inline-block;
    margin: 30px auto;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
